var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.181,
    height: 33.181,
    viewBox: "0 0 33.181 33.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_mask",
    "data-name": "vuesax/bulk/mask",
    transform: "translate(-492 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask",
    transform: "translate(492 380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.568,13.784a13.674,13.674,0,0,1-4.59,10.245,13.6,13.6,0,0,1-9.194,3.539A13.784,13.784,0,1,1,13.784,0a13.6,13.6,0,0,1,9.194,3.539A13.674,13.674,0,0,1,27.568,13.784Z",
    transform: "translate(2.807 2.807)",
    fill: "#a93efc",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.9,14.594c-.028,2.281-1.728,2.834-3.318,2.2a8.922,8.922,0,0,1,0-16.549c1.59-.636,3.29-.069,3.318,2.2Z",
    transform: "translate(7.645 8.065)",
    fill: "#a93efc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H33.181V33.181H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.d62ccf6585af42b1791d94cf97cd4506.svg";
export { ForwardRef as ReactComponent };